import React from 'react';
import { styled } from '@linaria/react';
import { useTheme } from 'src/theme';

const ImageElement = styled.img<StyledProps>`
  width: ${props => props.width}px;
  svg {
    fill: black;
  }
  
  &.close-red {
    width: 12px;
    position: relative;
    left: -2px;
    top: 0px;
  }
`
interface StyledProps {
  width: number;
}

export interface IconProps {
  id?: string | undefined;
  className?: string | undefined;
  theme?: any;
  name: string;
  size: 'xsm' | 'sm' | 'md' | 'lg' | 'dlg';
}

function importAllIcons(assets: __WebpackModuleApi.RequireContext) {
  const imageSet: Record<string, string> = {};

  assets.keys().map((image) => {
    imageSet[image.replace("./", "")] = assets(image);
  });
  return imageSet;
}

function Icon({ name, size, className, id }: IconProps) {
  const theme = useTheme();
  const width = theme.iconSize[size];
  // @ts-ignore
  const icons = importAllIcons(require.context("@assets/icon/", false, /\.(svg)$/));
  return <ImageElement id={id} className={className} src={icons[`${name}.svg`]} width={width} />;
};

Icon.defaultProps = {
  name: 'download',
  size: 'sm'
}

export default Icon;
